import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactElement } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import useCaseAttachmentById from "../../modules/filestore/hooks/useCaseAttachmentById";
import useEUFinanceCurrentUser from "../../modules/filestore/hooks/useEUFinanceCurrentUser";
import CaseAttachmentDownloader from "./components/CaseAttachmentDownloader";

const CLASSNAME = "eu-finance-case-attachment-downloader";

enum QueryParam {
  CASE_ATTACHMENT_ID = "finRequestsFileId",
}

const EUFinanceFileDownload: FC = (): ReactElement => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const caseAttachmentId = queryParams.get(QueryParam.CASE_ATTACHMENT_ID);

  const { data: currentUser, isLoading: isLoadingCurrentUser } =
    useEUFinanceCurrentUser();

  const { data: caseAttachment, isLoading: isLoadingCaseAttachment } =
    useCaseAttachmentById(caseAttachmentId);

  if (isLoadingCurrentUser || isLoadingCaseAttachment) {
    return (
      <div
        className={`${CLASSNAME}__loading d-flex justify-content-center align-items-center`}
      >
        <FontAwesomeIcon icon={faSpinner} spin size="10x" />
      </div>
    );
  }

  if (!currentUser?.id) {
    return (
      <div className={`${CLASSNAME}__error`}>
        <Container fluid>
          <Row>
            <Col className="mt-3">
              <Alert variant="danger">
                Oops! We could not locate your account. Try signing in again or
                contact support if the issue continues.
              </Alert>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (!caseAttachmentId || !caseAttachment?.id) {
    return (
      <div className={`${CLASSNAME}__error`}>
        <Container fluid>
          <Row>
            <Col className="mt-3">
              <Alert variant="danger">
                Failed to load page. Please try again later or contact support
                if the issue continues.
              </Alert>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className={CLASSNAME}>
      <CaseAttachmentDownloader caseAttachment={caseAttachment} />
    </div>
  );
};

export default EUFinanceFileDownload;
